<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="14">
        <RoleOptions
          ref="roleOptions"
          :userCode="userCode"
          @checkboxChange="(data) => $refs.roleTable.assignmentData(data)"
        />
      </el-col>
      <el-col :span="10">
        <RoleTable
          ref="roleTable"
          :userCode="userCode"
          @cancelCheck="(roleIds) => $refs.roleOptions.cancelCheck(roleIds)"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import RoleTable from './role-table'
import RoleOptions from './role-options'
export default {
  components: { RoleTable, RoleOptions },
  props: { userCode: { type: String, default: '' } },

  methods: {
    getTableData() {
      console.log(
        'this.$refs.roleOptions.getTableData()',
        this.$refs.roleOptions.getTableData()
      )
      return this.$refs.roleOptions.getTableData()
    },
  },
}
</script>

<style scoped></style>
